import { useCallback, useState, useRef, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import { TranslationService } from "../../../services/TranslationService";
import CompanyService from "../../../services/CompanyService";
import ButtonPrimary from "../../account/components/ButtonPrimary";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { Cast } from "../../../utils/Utils";

type PaymentMethodsType = {
  paymentMethod: string;
};
type EditorType = { onChange: (state: EditorState) => void };

export const PaymentMethods = ({ paymentMethod }: PaymentMethodsType) => {
  const editorRef = useRef<null | EditorType>(null);
  const [saveData, setSaveData] = useState(false);
  const [content, setContent] = useState<string>(paymentMethod);

  const getDefaultState = () => {
    const blocksFromHtml = htmlToDraft(paymentMethod ?? "");
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(
      contentBlocks,
      entityMap
    );
    convertToRaw(contentState);
    return EditorState.createWithContent(contentState);
  };
  const defaultEditorState = useRef(getDefaultState());

  const saveValues = useCallback(() => {
    setSaveData(false);
    CompanyService.setConfigCompany({ paymentMethod: content });
  }, [content]);

  useEffect(() => {
    // Busca el div contentEditable dentro de nuestra clase
    const editorNode = document.querySelector<HTMLElement>(
      ".rdw‐editor‐noext [contenteditable='true']"
    );
    if (!editorNode) return;

    // Atributos anti‑Grammarly
    editorNode.setAttribute("data-gramm", "false");
    editorNode.setAttribute("data-gramm_editor", "false");
    editorNode.setAttribute("data-enable-grammarly", "false");

    // Atributos anti‑Translate u otras inyecciones
    editorNode.setAttribute("spellcheck", "false");
    editorNode.setAttribute("autocorrect", "off");
    editorNode.setAttribute("autocomplete", "off");
    editorNode.setAttribute("autocapitalize", "off");
    editorNode.setAttribute("translate", "no");
  }, []); // sólo al montar

  return (
    <div className="mx-3 align-items-end">
      <div className="col-12">
        <Editor
          defaultEditorState={defaultEditorState.current}
          wrapperClassName="rdw‐wrapper‐noext" // para el contenedor
          editorClassName="rdw‐editor‐noext" // para el div editable
          onEditorStateChange={(editorState) => {
            setSaveData(true);
            const rawContentState = convertToRaw(
              editorState.getCurrentContent()
            );
            const markup = draftToHtml(rawContentState, {}, false);
            setContent(markup);
            defaultEditorState.current = editorState;
          }}
          locale={TranslationService.currentLanguage}
          ref={(x) => (editorRef.current = Cast<EditorType>(x))}
        />
      </div>
      {saveData && (
        <div
          className="col-12 mt-2"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end"
          }}
        >
          <ButtonPrimary onClick={saveValues}>
            {TranslationService.translate.Save}
          </ButtonPrimary>
        </div>
      )}
    </div>
  );
};
